module.exports = __webpack_public_path__ + "static/media/card.7e718e07.png";